import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { Avatar } from '@/components/Avatar'
import { RemoveClientTeamDialog } from '@/features/jobs/details/components/RemoveClientTeamDialog'
import { type RemoveClientTeamDialogViewModel } from './RemoveClientTeamDialogViewModel'

export interface RemoveClientTeamDialogContainerProps {
  vm: RemoveClientTeamDialogViewModel
}

export const RemoveClientTeamDialogContainer = observer(
  function RemoveClientTeamDialogContainer({
    vm,
  }: RemoveClientTeamDialogContainerProps) {
    return (
      <RemoveClientTeamDialog
        showing={vm.modal.showing}
        clientTeamField={
          <TextInputContainer
            readOnly
            isDisabled
            visual={<Avatar size={24} subject={vm.currentClientTeam} />}
            field="currentClientTeamName"
            model={vm}
          />
        }
        reasonField={
          <TextAreaContainer
            model={vm}
            field="reason"
            name="reason"
            error={vm.validation.getError('reason')}
            data-test="remove-client-team-reason-input"
            rows={3}
          />
        }
        reasonHelpText={vm.reasonHelpText}
        isRemovePending={vm.removeClientTeam.pending}
        isRemoveRejected={vm.removeClientTeam.rejected}
        removeError={vm.removeClientTeam.error}
        onClose={vm.modal.close}
        onRemove={vm.removeClientTeam}
        closeButtonTestId="remove-client-team-close-button"
        submitButtonTestId="remove-client-team-submit-button"
      />
    )
  },
)
